import { useEffect, useState } from "react";
import { subscribeUserUiPreferences } from "../lib/userUiPreferencesSync.js";

export default function useLiveUserUiPreference(section, fallback, busy = false) {
  const [received, setReceived] = useState(undefined);
  useEffect(() => subscribeUserUiPreferences(section, (value) => {
    if (busy) return false;
    setReceived(value);
    return true;
  }), [section, busy]);
  return received === undefined ? fallback : received;
}
